import FilterMenuItem from './FilterMenuItem';

export default FilterMenuItem;